import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';
import "./index.scss";

import ProfileAvatar from "../../../../../../ui/ProfileAvatar";
import Pagination from "../../../../../../ui/Pagination";
import NoDataFound from "../../../../../../ui/NoDataFound";
import SkeletonLoader from "../../../../../../ui/SkeletonLoader";

import { getTechnologiesImageUrl } from "../../../../../../../utils/util";

import { useSelector, useDispatch } from 'react-redux';
import { getSubDomainTechnologies } from "../../../../../../../store/actions/scanInfoAction";

const Technologies = ({selectedSubdomain, domainId, scanId}) => {

    const subDomainTechnologies = useSelector((state) => state?.scanInfo.subDomainTechnologies);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null)

    const dispatch = useDispatch();

    const [technologiesList, setTechnologiesList] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const fetchRecordData = useCallback(()=>{
        setIsLoading(true)
        const url = `&page=${currentPage}&page_size=${currentPageSize}&subdomain=${selectedSubdomain?.subdomain}&domain=${selectedSubdomain?.domain}&scan_id=${selectedSubdomain?.scan_id}`
        dispatch(getSubDomainTechnologies(url))
    },[dispatch, currentPage, currentPageSize, selectedSubdomain])

    useEffect(()=>{
        if(selectedSubdomain || domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {
            setCurrentPage(1);
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId
        }
    },[domainId, scanId, selectedSubdomain]);

    useEffect(()=>{
        fetchRecordData()
    },[currentPageSize, currentPage, fetchRecordData])

    useEffect(()=>{
        if(subDomainTechnologies !== null) {
            setIsLoading(false)
            setTechnologiesList(subDomainTechnologies)
        }
    },[subDomainTechnologies])

    return (
        <div className="record-container-content">
            <div className="table-container mt-3 record-table p-2 subdomain-technologies-table">
                {
                    isLoading ?
                    <SkeletonLoader type={"line"} count={5} currentPage={"technologies"} />
                    :
                    <Table responsive="lg">
                        <thead>
                            <tr>
                                <th>Port</th>
                                <th>Name</th>
                                <th>Version</th>
                                <th>Description</th>
                                <th>Category</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                technologiesList !== "" && technologiesList?.results?.length > 0 && 
                                technologiesList?.results?.map((data, index) => {
                                    return (
                                        <motion.tr
                                            key={index}
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                        >
                                            <td>
                                                {data?.port}
                                            </td>
                                            <td>
                                                <ProfileAvatar type={"profile"} firstName={data?.name} lastName={""} imageUrl={getTechnologiesImageUrl(data)}/>
                                            </td>
                                            <td>
                                                <p>{data?.version !== null ? data?.version : "-"}</p>
                                            </td>
                                            <td>
                                                <p>{data?.description}</p>
                                            </td>
                                            <td>
                                                <p className="technologies-category">
                                                    {
                                                        data?.categories?.length > 0 ?
                                                        data?.categories?.map((cat, i)=>{
                                                            return (
                                                                <span key={i}>{cat}</span>
                                                            )                                                            
                                                        }) : "-"
                                                    }
                                                </p>
                                            </td>
                                        </motion.tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                }
                {
                    !isLoading && technologiesList !== "" && technologiesList?.results?.length === 0 &&
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        <NoDataFound noDataText={"No Record Found"}/>
                    </motion.div>                    
                }
                {technologiesList !== "" && technologiesList?.results?.length > 0 && <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    pageSize={currentPageSize}
                    totalCount={technologiesList?.meta?.total_results}
                    onPageChange={setCurrentPageandRecordSize}
                />}                
            </div>            
        </div>
    )
}

export default Technologies;